import usePipelineOutput from './usePipelineOutput';
import useIntegrationOutput from './useIntegrationOutput';
import useServerResponse from './useServerResponse';
import buildOnInputEventChange from './buildOnInputEventChange';
import useTestPipelineTabs from './useTestPipelineTabs';
import buildOnPipelineIntegrationChange from './buildOnPipelineIntegrationChange';
import buildDisabledTabs from './buildDisabledTabs';
import useHandlePipelineIntegrationsUpdate from './useHandlePipelineIntegrationsUpdate';

export default function useTestPipelineChainState({
  pipelineIntegration,
  parsedInputEvent,
  hasValidInputEvent,
  validatingEvent,
}) {
  const [selectedTab, { onSelectTab }] = useTestPipelineTabs();
  const [executePipelineTransform, pipelineOutput] = usePipelineOutput();
  const [executeIntegrationTransform, integrationOutput] = useIntegrationOutput({
    pipelineIntegration,
  });

  const serverResponse = useServerResponse({
    pipelineIntegration,
    integrationOutput,
    originalEvent: parsedInputEvent,
  });

  const onPipelineIntegrationChange = buildOnPipelineIntegrationChange({
    integrationOutput,
    serverResponse,
    selectedTab,
    onSelectTab,
  });

  useHandlePipelineIntegrationsUpdate({ pipelineIntegration, onPipelineIntegrationChange });

  const onInputEventChange = buildOnInputEventChange({
    pipelineOutput,
    integrationOutput,
    serverResponse,
  });

  const disabledTabs = buildDisabledTabs({
    hasValidInputEvent,
    validatingEvent,
    pipelineIntegration,
    pipelineOutput,
    integrationOutput,
  });

  return {
    selectedTab,
    onSelectTab,
    onInputEventChange,
    onPipelineIntegrationChange,
    ...disabledTabs,
    executePipelineTransform: () => executePipelineTransform({ parsedInputEvent }),
    executeIntegrationTransform: () =>
      executeIntegrationTransform({
        inputEvent: pipelineOutput.outputEvent,
        originalEvent: parsedInputEvent,
      }),
    pipelineOutput,
    integrationOutput,
    serverResponse,
  };
}
